(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var panel = document.querySelector('[data-pnm-product]');
    if (!panel) return;

    var subDropdown = document.querySelector('[data-mixed-sub-dropdown]');
    var productId = panel.dataset.pnmProduct;
    var discountPct = parseInt(panel.dataset.pnmDiscount || '15', 10);
    var dataEl = document.getElementById('pnm-variants-' + productId);
    if (!dataEl) return;

    var allVariants = JSON.parse(dataEl.textContent);

    var caseMap = {};
    var caseEl = document.getElementById('pnm-case-' + productId);
    if (caseEl) {
      JSON.parse(caseEl.textContent).forEach(function (c) {
        var m = c.pack.match(/\((\d+)\)/);
        if (m) caseMap[parseInt(m[1], 10)] = { id: c.id, price: c.price };
      });
    }

    // Group by flavour: { "Lager": { img, id } } — one "Single" variant per flavour
    var flavourMap = {};
    var flavourOrder = [];
    allVariants.forEach(function (v) {
      if (!flavourMap[v.flavour]) {
        flavourMap[v.flavour] = { img: v.img, id: v.id };
        flavourOrder.push(v.flavour);
      }
    });

    var counts = {};
    flavourOrder.forEach(function (f) { counts[f] = 0; });

    var MILESTONES = [6, 12, 24, 48];

    function totalCount() {
      return flavourOrder.reduce(function (sum, f) { return sum + counts[f]; }, 0);
    }

    function activeTier(total) {
      if (total === 48) return 48;
      if (total === 24) return 24;
      if (total === 12) return 12;
      if (total === 6) return 6;
      return null;
    }

    function nextMilestone(total) {
      for (var i = 0; i < MILESTONES.length; i++) {
        if (total < MILESTONES[i]) return MILESTONES[i];
      }
      return MILESTONES[MILESTONES.length - 1];
    }

    function formatPrice(pence) {
      return '£' + (pence / 100).toFixed(2);
    }

    // --- Build ATC button next to the normal one ---
    var normalAtcBtn = document.querySelector('button[data-add-to-cart]');
    var normalAtcContainer = normalAtcBtn ? normalAtcBtn.closest('.product__submit__item') : null;

    var pnmAtcWrapper = document.createElement('div');
    pnmAtcWrapper.className = 'product__submit__item pnm-atc-wrapper';
    pnmAtcWrapper.style.display = 'none';

    var pnmAtcBtn = document.createElement('button');
    pnmAtcBtn.type = 'button';
    pnmAtcBtn.className = 'btn btn--primary btn--solid';
    pnmAtcBtn.disabled = true;
    pnmAtcBtn.innerHTML = '<span class="btn__text">Add to Cart</span>';
    pnmAtcWrapper.appendChild(pnmAtcBtn);

    if (normalAtcContainer && normalAtcContainer.parentNode) {
      normalAtcContainer.parentNode.insertBefore(pnmAtcWrapper, normalAtcContainer.nextSibling);
    }

    var packSizeFieldset = document.querySelector('[data-pack-size-options]');
    var quantitySelector = document.querySelector('.quantity-selector');
    var productForm = document.querySelector('form[data-product-form]');
    var productFormEl = productForm ? productForm.closest('product-form') : null;

    function showPickNMix() {
      panel.removeAttribute('hidden');
      if (packSizeFieldset) packSizeFieldset.style.display = 'none';
      if (quantitySelector) quantitySelector.style.display = 'none';
      if (normalAtcContainer) normalAtcContainer.style.display = 'none';
      pnmAtcWrapper.style.display = '';
      if (productForm) productForm.classList.add('pick_n_mix_active');
      if (productFormEl) productFormEl.classList.add('pick_n_mix_active');

      if (typeof window.showVariantGallery === 'function') {
        window.showVariantGallery('Pick n Mix');
      }

      requestAnimationFrame(function () {
        var top = panel.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    }

    function hidePickNMix() {
      panel.setAttribute('hidden', '');
      if (packSizeFieldset) packSizeFieldset.style.display = '';
      if (quantitySelector) quantitySelector.style.display = '';
      if (normalAtcContainer) normalAtcContainer.style.display = '';
      pnmAtcWrapper.style.display = 'none';
      if (productForm) productForm.classList.remove('pick_n_mix_active');
      if (productFormEl) productFormEl.classList.remove('pick_n_mix_active');
      // Uncheck the pick-n-mix sub-radio so returning to Mixed auto-selects the first real sub-option
      if (subDropdown) {
        var pnmRadio = subDropdown.querySelector('input[value="pick-n-mix"]');
        if (pnmRadio) pnmRadio.checked = false;
      }
    }

    function render() {
      var total = totalCount();
      var rowsEl = panel.querySelector('[data-pnm-rows]');

      if (!rowsEl.dataset.built) {
        rowsEl.dataset.built = '1';
        flavourOrder.forEach(function (flavour) {
          var data = flavourMap[flavour];
          var row = document.createElement('div');
          row.className = 'pnm-row';
          row.dataset.flavour = flavour;
          row.innerHTML =
            '<img src="' + (data.img || '') + '" alt="' + flavour + '" class="pnm-row-img">' +
            '<span class="pnm-row-title">' + flavour + '</span>' +
            '<div class="pnm-row-counter">' +
            '<button type="button" class="pnm-btn pnm-dec" data-action="dec">−</button>' +
            '<span class="pnm-qty" data-qty>0</span>' +
            '<button type="button" class="pnm-btn pnm-inc" data-action="inc">+</button>' +
            '</div>';
          rowsEl.appendChild(row);
        });

        rowsEl.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-action]');
          if (!btn) return;
          var row = btn.closest('.pnm-row');
          var flavour = row.dataset.flavour;
          if (btn.dataset.action === 'inc') {
            if (totalCount() < 48) counts[flavour]++;
          } else {
            if (counts[flavour] > 0) counts[flavour]--;
          }
          render();
        });
      }

      // Update qty displays
      panel.querySelectorAll('.pnm-row').forEach(function (row) {
        row.querySelector('[data-qty]').textContent = counts[row.dataset.flavour];
      });

      // Progress bar (capped at 48)
      var fill = panel.querySelector('[data-pnm-fill]');
      fill.style.width = Math.min(total / 48 * 100, 100) + '%';

      // Milestone markers
      panel.querySelectorAll('[data-milestone]').forEach(function (m) {
        m.classList.toggle('pnm-milestone--reached', total >= parseInt(m.dataset.milestone, 10));
      });

      // Count / target label
      var tier = activeTier(total);
      var next = nextMilestone(total);
      panel.querySelector('[data-pnm-count]').textContent = total;
      panel.querySelector('[data-pnm-target]').textContent = next;

      // Per-can price label — derived from case price ÷ quantity
      var tierEl = panel.querySelector('[data-pnm-tier]');
      var displayTier, showAddMore;
      if (total >= 48) {
        displayTier = 48; showAddMore = false;
      } else if (tier && total === tier) {
        displayTier = tier; showAddMore = false;
      } else {
        displayTier = next; showAddMore = true;
      }
      var displayCaseData = caseMap[displayTier];
      if (displayCaseData) {
        var perCan = Math.round(displayCaseData.price / displayTier);
        tierEl.textContent = showAddMore
          ? 'Add ' + (displayTier - total) + ' more — ' + formatPrice(perCan) + ' per can'
          : formatPrice(perCan) + ' per can';
      } else {
        tierEl.textContent = '';
      }

      // Combined total price — only shown at an exact milestone
      var totalEl = panel.querySelector('[data-pnm-total]');
      var subEl = panel.querySelector('[data-pnm-sub-price]');
      var caseData = tier ? caseMap[tier] : null;
      var displayPrice = caseData ? caseData.price : null;
      var subPence = displayPrice ? Math.round(displayPrice * (1 - discountPct / 100)) : null;
      if (totalEl) totalEl.textContent = displayPrice ? 'One-time purchase: ' + formatPrice(displayPrice) : '';
      if (subEl) subEl.textContent = subPence ? 'Subscribe & Save ' + discountPct + '%: ' + formatPrice(subPence) : '';

      // ATC button — only active at a milestone
      pnmAtcBtn.disabled = !tier;
    }

    // Show/hide panel when pick-n-mix radio changes
    if (subDropdown) {
      subDropdown.querySelectorAll('input[name="pseudo-mixed-pack"]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (this.value === 'pick-n-mix') {
            showPickNMix();
          } else {
            hidePickNMix();
          }
        });
      });

      // Apply on load if already checked
      var checkedPnm = subDropdown.querySelector('input[value="pick-n-mix"]:checked');
      if (checkedPnm) showPickNMix();
    }

    // When a top-level Flavour radio (Lager / Pale Ale) is selected, fully reset PNM state
    document.querySelectorAll('input[name^="options[Flavour]"]').forEach(function (radio) {
      if (subDropdown && subDropdown.contains(radio)) return;
      radio.addEventListener('change', function () {
        hidePickNMix();
      });
    });

    // ATC submit
    pnmAtcBtn.addEventListener('click', function () {
      var total = totalCount();
      var tier = activeTier(total);
      if (!tier) return;

      // Bundle quantity multiplier — reuse the product form's quantity input
      var qtyInput = document.querySelector('input[name="quantity"]');
      var bundleQty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;

      var form = document.querySelector('[data-product-form], form[action*="/cart/add"]');
      var sellingPlan = null;
      if (form) {
        var spInput = form.querySelector('input[name="selling_plan"]');
        if (spInput && spInput.value) sellingPlan = spInput.value;
      }

      pnmAtcBtn.disabled = true;
      pnmAtcBtn.querySelector('.btn__text').textContent = 'Adding…';

      var cartRoot = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';

      // Prefetch cart to count existing PNM bundles so this bundle gets the correct sequential number.
      // Using actual cart state (not a session counter) means the number stays correct after page refreshes.
      fetch(cartRoot + 'cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var existingBundleIds = new Set();
          cart.items.forEach(function (item) {
            if (item.properties && item.properties['_bundle_id']) {
              existingBundleIds.add(item.properties['_bundle_id']);
            }
          });
          var bundleNum = existingBundleIds.size + 1;
          var bundleId = 'pnm-' + Date.now();

          // Human-readable breakdown of the selected cans, stashed on the case item as a
          // fallback record. The case item is the one guaranteed to reach the order even if
          // the separate fulfilment-items request below fails — this property lets support
          // reconstruct which cans/quantities were picked if that ever happens again.
          var selectionParts = [];
          flavourOrder.forEach(function (flavour) {
            var qty = counts[flavour];
            if (qty <= 0) return;
            selectionParts.push(flavour + ' x' + (qty * bundleQty));
          });
          var selectionStr = selectionParts.join(', ');

          var items = [];
          var atcCaseData = caseMap[tier] || null;

          if (atcCaseData) {
            // Case item — non-physical variant, auto-fulfilled by Shopify, invisible to Mintsoft
            var caseItem = {
              id: atcCaseData.id,
              quantity: bundleQty,
              properties: {
                '_pick_n_mix': 'true',
                '_bundle_id': bundleId,
                '_pnm_case': 'true',
                '_pnm_selection': selectionStr,
                'Bundle': 'Pick n Mix ' + bundleNum
              }
            };
            if (sellingPlan) caseItem.selling_plan = sellingPlan;

            // Fulfilment items — physical, £0, for Mintsoft picking. Submitted with selling_plan
            // so Seal includes them in subscription renewals (15% of £0 = £0, no price impact).
            // Sent in a separate request AFTER the case item so Seal's interception of the first
            // request cannot drop these items.
            var fulfilmentItems = [];
            flavourOrder.forEach(function (flavour) {
              var qty = counts[flavour];
              if (qty <= 0) return;
              var flavourData = flavourMap[flavour];
              if (!flavourData) return;
              var fulfilmentItem = {
                id: flavourData.id,
                quantity: qty * bundleQty,
                properties: {
                  '_pick_n_mix': 'true',
                  '_bundle_id': bundleId,
                  '_pnm_fulfilment': 'true'
                }
              };
              if (sellingPlan) fulfilmentItem.selling_plan = sellingPlan;
              fulfilmentItems.push(fulfilmentItem);
            });

            // Submit case item first, then fulfilment items in a separate request so Seal
            // Subscriptions (which intercepts selling_plan requests) cannot strip the second batch.
            return fetch(cartRoot + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [caseItem] })
            }).then(function (res) {
              if (!res.ok) return res;
              if (!fulfilmentItems.length) return res;
              return fetch(cartRoot + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: fulfilmentItems })
              });
            });
          } else {
            // Fallback: no case variants configured — original behaviour
            flavourOrder.forEach(function (flavour) {
              var qty = counts[flavour];
              if (qty <= 0) return;
              var flavourData = flavourMap[flavour];
              if (!flavourData) return;
              var item = {
                id: flavourData.id,
                quantity: qty * bundleQty,
                properties: {
                  '_pick_n_mix': 'true',
                  '_bundle_id': bundleId,
                  'Bundle': 'Pick n Mix ' + bundleNum
                }
              };
              if (sellingPlan) item.selling_plan = sellingPlan;
              items.push(item);
            });
          }

          if (!items.length) return;

          return fetch(cartRoot + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (res) {
          if (!res) return;
          // Delegate the full cart refresh to the theme's CartItems element —
          // its getCart() fetches the section, injects HTML, dispatches events,
          // and opens the drawer, identical to the normal ATC flow.
          var cartItemsEl = document.querySelector('cart-items');
          if (cartItemsEl && typeof cartItemsEl.getCart === 'function') {
            cartItemsEl.getCart();
          }
        })
        .catch(function (err) { console.error('PnM cart error', err); })
        .finally(function () {
          pnmAtcBtn.disabled = false;
          pnmAtcBtn.querySelector('.btn__text').textContent = 'Add to Cart';
        });
    });

    render();
  });
})();
